<template>
  <div class="loading_box">
    <div class="main">
      <img class="pic" src="../assets/img/components/sign/loading.gif" alt="加载中" />
      <div class="label" v-if="!label">
        正在定位
        <span
          :style="{visibility: idx + 1 <= tick ? 'visible' : 'hidden'}"
          v-for="(n, idx) in 3"
          :key="n"
        >.</span>
      </div>
      <div class="label" v-else>{{label}}</div>
      <div class="btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    delay: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      tick: 0,
      label: '',
    };
  },
  mounted() {
    this.timer = null;
    this.timer5 = setTimeout(() => {
      this.label = '请再稍等5秒或取消后重试';
    }, 1000 * 5);
    this.timer10 = setTimeout(() => {
      this.label = '手机定位性能较弱，建议寻找工友协助打卡';
    }, 1000 * 10);
    this.startTick();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.timer5);
    clearTimeout(this.timer10);
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    startTick() {
      const { tick, delay } = this;
      let nextTick = tick + 1;
      if (nextTick > 3) {
        nextTick = 0;
      }
      this.tick = nextTick;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.startTick();
      }, delay);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading_box {
  margin-top: 4.7rem;
}

.loading_box .main {
  width: 11rem;
  padding: 1rem 0 0.75rem;
  background: #fff;
  border-radius: 0.6rem;
  overflow: hidden;
  margin: auto;
}

.loading_box .main .pic {
  display: block;
  width: 11rem;
  height: 11rem;
  margin: auto;
}

.loading_box .main .label {
  margin-top: 1rem;
  font-size: 0.8rem;
  color: #858B96;
  text-align: center;
  overflow: hidden;
}

.loading_box .main .btn {
  margin: 1.5rem auto 0;
  width: 9rem;
  height: 2.2rem;
  line-height: 2.2rem;
  background: #377fee;
  border-radius: 0.3rem;
  color: #fff;
  text-align: center;
  font-size: 0.8rem;
}
</style>
